import { METRIC_OPTIONS, METRIC_AGGREGATION_CONFIG } from 'features/admin/lib/metrics';

import { useMemo } from 'react';
import { aggregateData, AggregatedItem } from 'features/admin/lib/aggregateData';
import { MetricData } from 'features/admin/model/IMetrics';

export const useChartData = ({
    metricsData,
    aggregation,
    dateRange,
    selectedMetrics,
}: {
    metricsData: MetricData[];
    aggregation: 'day' | 'week' | 'month';
    dateRange: { startDate: Date; endDate: Date };
    selectedMetrics: string[];
}) => {

    return useMemo(() => {
        const processedData =
            aggregation === 'day'
                ? metricsData
                : aggregateData({
                    data: metricsData,
                    aggType: aggregation,
                    periodStart: dateRange.startDate,
                    periodEnd: dateRange.endDate,
                    selectedMetrics,
                    aggregationConfig: METRIC_AGGREGATION_CONFIG,
                });

        const sortedData = [...processedData].sort(
            (a, b) =>
                new Date(a.date_metrics).getTime() -
                new Date(b.date_metrics).getTime(),
        );
        return {
            datasets: METRIC_OPTIONS
                .filter(option => selectedMetrics.includes(option.id))
                .map(option => ({
                    label: option.label,
                    data: sortedData.map(item => {
                        if (aggregation === 'day') {
                            const m = item as MetricData;

                            return {
                                x: m.date_metrics.split('T')[0],
                                y: Math.round(Number(m[option.id]) || 0),
                                meta: {
                                    bucketStart: m.date_metrics.split('T')[0],
                                    bucketEnd: m.date_metrics.split('T')[0],
                                    aggregation,
                                },
                            };
                        }

                        const a = item as AggregatedItem;

                        return {
                            x: a.bucket_start,
                            y: Math.round(Number(a[option.id]) || 0),
                            meta: {
                                bucketStart: a.bucket_start,
                                bucketEnd: a.bucket_end,
                                aggregation,
                            },
                        };
                    }),
                    borderColor: option.color,
                    backgroundColor: option.color + '20',
                    borderWidth: 2,
                    pointRadius: 0,
                    pointHoverRadius: 8,
                    tension: 0.1,
                })),
        };
    }, [metricsData, aggregation, dateRange, selectedMetrics]);
};